import React, { Component } from 'react'
import { Link } from 'react-router-dom';

// components
import Sidemenu from '../../../components/sidemenu'
import Header from '../../../components/dashHeader'

//import SimpleSlider from '../../../components/other/simpleSlider'

//css 
import '../../styles/dashboard/Home.css'

// assets
import Arrow from '../../../assets/icons/forward.svg'
import Arrow2 from '../../../assets/svg/other/forward2.svg'
import Back from '../../../assets/svg/back-arrow.svg'
import M from '../../../assets/svg/other/moon.svg'
import S from '../../../assets/svg/other/simp.svg'
import B from '../../../assets/svg/other/bank.svg'
// import Check2 from '../../../assets/icons/pop-check.svg'
// import Cancel from '../../../assets/icons/sm-x.svg'
// import SArrow from '../../../assets/svg/other/s-arrow.svg'
// import Gdot from '../../../assets/icons/green-dot.svg'

export default class Home3PBuy extends Component {


    render() {

        const currentPage = "Home";

        return (
            <div>
                <Sidemenu currentPage={currentPage} />
                <Header />


                <section className="home">
                    <div className="home-container">
                        <div className="home-buy-content">
                            <Link to="/dashboard/home">
                            <img src={Back} className="w-backarrow" alt="back" />
                            </Link>
                            <h1> Third Party Buy </h1>
                            <div className="home-nav">
                                <Link to="/dashboard/home" className="right-e"><p className="ash"> Home </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <p><span className="bold"> Third Party Buy</span></p>
                            </div>
                            <div className="p3buy-content">
                                <p className="p3buy-title">Choose a third party buy service you would like to buy from</p>
                                <div className="p3buy-boxes">
                                    <Link to="/dashboard/home3pbuyaddress"className="p3buy-single-box">
                                        <div className="p3s-left">
                                            <h2>0.003687 BTC</h2>
                                            <p className="p3s-info">1 ETH = 1251.04 USD・All fees included</p>
                                            <div className="p3s-bottom">
                                                <p className="right-m1">Powered by  </p>
                                                <img src={M} alt="moonpay"/>
                                            </div>
                                           
                                        </div>
                                        <div className="p3s-right">
                                            <img src={Arrow2} alt="arrow"/>
                                        </div>
                                    </Link>
                                    <Link to="/dashboard/home3pbuyaddress" className="p3buy-single-box">
                                        <div className="p3s-left">
                                            <h2>0.003687 BTC</h2>
                                            <p className="p3s-info">1 ETH = 1251.04 USD・All fees included</p>
                                            <div className="p3s-bottom">
                                                <p className="right-m1">Powered by  </p>
                                                <img src={S} alt="moonpay"/>
                                            </div>
                                        </div>
                                        <div className="p3s-right">
                                            <img src={Arrow2} alt="arrow"/>
                                        </div>
                                    </Link>
                                    <Link to="/dashboard/home3pbuyaddress" className="p3buy-single-box">
                                        <div className="p3s-left">
                                            <h2>0.003687 BTC</h2>
                                            <p className="p3s-info">1 ETH = 1251.04 USD・All fees included</p>
                                            <div className="p3s-bottom">
                                                <p className="right-m1">Powered by  </p>
                                                <img src={B} alt="moonpay"/>
                                            </div>
                                           
                                        </div>
                                        <div className="p3s-right">
                                            <img src={Arrow2} alt="arrow"/>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            
                        </div>
                       
                    </div>
                </section>
            </div>
        )
    }
}
